import {FETCH_ASSETLIST_BEGIN,FETCH_ASSETLIST_SUCCESS,FETCH_ASSETLIST_FAILURE} from '../constants/assets';

const initialState={
    assetList:[],
    isLoading:false,
    error:""
}


export const getAssetListReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_ASSETLIST_BEGIN: {
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      }
    case FETCH_ASSETLIST_FAILURE:
        return {
            ...initialState,
            isLoading:false,
            assetList:null
        };
    case FETCH_ASSETLIST_SUCCESS:
        return {
            ...initialState,
            assetList:payload.assetDataItems,
            isLoading:true,
        };
    default:
        return state;
 }
}

export default getAssetListReducer
